/** Idle-session policy (AUTH-008). One place so the monitor and its tests agree on the numbers. */
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
/** How long the warning is shown before sign-out. */
export const IDLE_WARNING_MS = 60 * 1000;
/** DOM events that count as user activity. Deliberately excludes mousemove (too noisy). */
export const ACTIVITY_EVENTS = ["pointerdown", "keydown", "wheel", "touchstart", "scroll"] as const;
